
import { create_thread_fail, delete_thread_fail, delete_thread_sucsess, fetch_thread_list_failed, fetch_thread_list_start_loading, fetch_thread_list_success } from "./reducer";
import { clear_context, create_new_thread, delete_Thread, delete_thread_bulk, edit_Thread_title, get_Threads } from "../../helpers/fakebackend_helper";
import { open_success_modal } from "../Success_Modal/reducer";
import { uniqueId } from "lodash";
import { Bot_Chat_History_mongo } from "../thunks";
import config from "../../config";





export const Bot_Thread = (filterData) => async (dispatch) => {



  try {
    let response;





    dispatch(fetch_thread_list_start_loading())
    
 
      response = get_Threads({Bot_ID:filterData});
    
    
    var data = await response;

     if(data.length === 0 && filterData){
   
       dispatch(Bot_Thread_Create(filterData))
     }


      

        dispatch(fetch_thread_list_success({ data}));

   
    
  } catch (error) {
    dispatch(fetch_thread_list_failed(error));
  }
};


export const Bot_Thread_Delete = (filterData) => async (dispatch) => {



    try {
      let response;


      // console.log(filterData);

  
  
  
  
  
      dispatch(fetch_thread_list_start_loading())
      
   
        response = delete_Thread(filterData.id);
      
      
        await response;
  
      // dispatch(open_success_modal("Thread Deleted Successfully"))
       
      response = get_Threads({Bot_ID:filterData.Bot_ID});
      dispatch(delete_thread_sucsess());

      let threads = await response;
      
      dispatch(fetch_thread_list_success({ data:threads}));
      
  
  
  
  
        
  
  
     
      
    } catch (error) {
      dispatch(delete_thread_fail(error));
    }
  };


  export const Bot_Thread_Delete_Bulk = (filterData) => async (dispatch) => {



    try {
      let response;


      // console.log(filterData);

  
  
  
  
  
      dispatch(fetch_thread_list_start_loading())
      
   
        response = delete_thread_bulk(filterData);
      
      
        await response;
  
      // dispatch(open_success_modal("Thread Deleted Successfully"))
       
      response = get_Threads({Bot_ID:filterData.Bot_ID});
      dispatch(delete_thread_sucsess());

      let threads = await response;
      
      dispatch(fetch_thread_list_success({ data:threads}));
      
  
  
  
  
        
  
  
     
      
    } catch (error) {
      dispatch(delete_thread_fail(error));
    }
  };



  export const Bot_Thread_Create = (filterData) => async (dispatch) => {



    try {
      let response;
  
  
  
      dispatch(fetch_thread_list_start_loading())
      
   
        response = create_new_thread({bot_id:filterData , run_id:uniqueId('run_id')});
      
      
        await response;
  
      // dispatch(open_success_modal("Thread Created Successfully"))
       
      response = get_Threads({Bot_ID:filterData});
   

      let threads = await response;
      
      dispatch(fetch_thread_list_success({ data:threads}));
      
  
  
  
  
        
  
  
     
      
    } catch (error) {
      dispatch(create_thread_fail(error));
    }
  };


  export const Bot_Thread_Create_Clear_Context = (filterData,type) => async (dispatch) => {



    try {
     
      
      if(type=='reset'){
        let response;
  
  
  
        dispatch(fetch_thread_list_start_loading())
        
     
          response = create_new_thread({assistant_id:filterData});
        
        
          await response;
  
         
    
         
        response = get_Threads({Bot_ID:filterData.Bot_ID});
     
  
        let threads = await response;
        
        dispatch(fetch_thread_list_success({ data:threads}));
        dispatch(open_success_modal("Chat Reset Successfully"))

      }else{


        let response;
  
  
  
 
        
     
          response = clear_context({thread_id:filterData , clear_context:true});
        
        
          await response;
  
         dispatch(
                 Bot_Chat_History_mongo({
                   session_id: filterData,
                   limit: config.general_config.chat_limit,
                 })
               );
    
         
        
        
        // dispatch(open_success_modal("Context Cleared Successfully"))
      }
  
  
  
        
  
  
     
      
    } catch (error) {
      dispatch(create_thread_fail(error));
    }
  };


  export const Update_Bot_Thread = (filterData) => async (dispatch) => {
    try {
      dispatch(fetch_thread_list_start_loading()); // Indicate loading state
  
      // Update the thread title
      await edit_Thread_title(filterData);
  
      // Fetch the updated list of threads
      const threadResponse = await get_Threads({ Bot_ID: filterData.Bot_ID });
  
      // Check if the thread list is empty and create a new thread if needed
      if (threadResponse.length === 0 && filterData) {
        await dispatch(Bot_Thread_Create(filterData.Bot_ID));
      }
  
      // Dispatch success action with the thread data
      dispatch(fetch_thread_list_success({ data: threadResponse }));
    } catch (error) {
      console.error("Error in Update_Bot_Thread:", error); // Log the error
      dispatch(fetch_thread_list_failed(error)); // Dispatch error action
    }
  };


  




  


  

